import React from 'react';

const VillageIcon = (props) => {
  return (
    <img
      alt="Skansen"
      src="/static/images/icons/place_types/village.svg"
      {...props}
    />
  );
};

export default VillageIcon;
